// Implements: F-UIX-004
/**
 * The one key the theme choice is persisted under.
 *
 * It is duplicated on purpose in `public/theme-init.js`, which runs before
 * the bundle exists and therefore cannot import anything (design DD10).
 * `storageKey.test.ts` asserts the two copies still say the same thing.
 */
export const THEME_STORAGE_KEY = "prototyper.theme";
